module.exports = __webpack_public_path__ + "img/adsorb.c5ce5709.png";